<template>
    <div>
        <label class="block text-sm font-medium leading-5 text-gray-800 relative"
            :class="{'required': required, 'font-bold' : bold}"
            :for="name"
            v-if="label">
            <span v-html="label"></span>
            <font-awesome-icon class="text-xs text-black ml-1 cursor-pointer"
                :icon="['fas', 'question-circle']"
                style="margin-top: 2px;"
                v-if="tooltip" v-tooltip="tooltip" />
        </label>
        <div class="mt-3">
            <ValidationProvider :name="providerName ? providerName : label" mode="lazy" :rules="rules" v-slot="{ errors }" tag="div">
                <div class="flex" :class="[ layout === 'vertical' ? 'flex-col' : 'flex-row flex-wrap' ]">
                    <label v-for="(option, optionIndex) in options" :key="optionIndex"
                        class="mr-4 flex flex-row items-center cursor-pointer"
                        :class="[ layout === 'vertical' ? 'mb-2' : '' ]"
                    >
                        <input type="radio" :value="option.value" :name="name" v-model="model" :readonly="readonly" @input="onInput"><span class="ml-1 text-sm">{{ option.label }}</span>
                    </label>
                </div>
                <span class="text-xs text-red-700 absolute">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InputText",
        props: ['label', 'value', 'name', 'providerName', 'readonly', 'rules', 'required', 'tooltip', 'disabled', 'blur', 'suffix', 'layout', 'options', 'bold'],
        data: function(){
            return {
                model: null
            }
        },
        mounted() {
            if (this.value){
                this.model = this.value;
            }
        },
        methods: {
            onInput (event) {
                if (event.target){
                    this.$emit('input', event.target.value);
                } else {
                    // Used for Masked Input
                    this.$emit('input', event);
                }
            }
        },
        watch: {
            value: function(newVal){
                this.model = newVal;
                this.$emit('input', newVal);
            },
        }
    }
</script>

<style scoped>

</style>
